import React from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import { Link, useLoaderData } from "react-router-dom";
import "./Refunds.css";
import LoaderSmall from "../../Shared/LoderSmall/LoaderSmall";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDHqLpPVzd0Y9SWTpSH1smRmbKv4WUvi-4",
  authDomain: "tutors-today-student.firebaseapp.com",
  projectId: "tutors-today-student",
  storageBucket: "tutors-today-student.appspot.com",
  messagingSenderId: "171808622362",
  appId: "1:171808622362:web:cb9ad091e01bba89988ea3",
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

const RequestRefundsDetails = () => {
  const data = useLoaderData();
  const [file, setFile] = useState(null);

  const Invoice = data._id;
  const InvoiceId = Invoice.slice(-6);

  console.log("data", data);

  const [isOpen, setIsOpen] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);

  const handleButtonClick = (data) => {
    setSelectedItem(data);
    setIsOpen(!isOpen);
  };

  const [inputNumber, setInputNumber] = useState("");
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [refundReason, setRefundReason] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const uploadedFiles = event.target.files;
    if (uploadedFiles.length > 0) {
      const fileLabels = Array.from(uploadedFiles)
        .map((file) => file.name)
        .join(", ");
      document.getElementById("fileLabel").innerText = fileLabels;
      setFile(Array.from(uploadedFiles));
    } else {
      document.getElementById("fileLabel").innerText = "JPG / PNG / PDF";
      setFile([]);
    }
  };

  const handleClassBooked = async () => {
    try {
      if (!inputNumber || !selectedPaymentMethod || !refundReason) {
        throw new Error("All fields are required.");
      }

      let imageURLString = "";

      // Upload the image to Firebase Storage if a file is selected
      if (file && file.length > 0) {
        const uploadPromises = file.map((uploadedFile) => {
          const storageRef = ref(storage, `uploads/${uploadedFile.name}`);
          return uploadBytes(storageRef, uploadedFile)
            .then((snapshot) => getDownloadURL(snapshot.ref));
        });
  
        try {
          const imageURLs = await Promise.all(uploadPromises);
          imageURLString = imageURLs.join(", "); // Concatenating URLs into a single string
          console.log("Files uploaded successfully!");
        } catch (error) {
          console.error("Error uploading files: ", error);
          throw new Error("Error uploading files");
        }
      }
  
      const requestData = {
        inputNumberAdminRefund: inputNumber,
        paymentMethodAdminRefund: selectedPaymentMethod,
        refundReasonAdminRefund: refundReason,
        AdminRefundImage: imageURLString, // Store the concatenated image URLs as a string
      };
  
      // Log the data before sending the request
      console.log("Data to be sent:", requestData);

  
      const response = await fetch(`https://tutor-tree-server-1.vercel.app/refundsRequestAdmin/${data._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
  
      if (!response.ok) {
        throw new Error("Failed to update refund request.");
      }
  
      const responseData = await response.json();
  
      if (responseData.modifiedCount > 0) {
        toast.success("Refund request updated successfully.");
        // Optionally, update the UI or re-fetch data as needed
      } else {
        throw new Error("No documents were modified.");
      }
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("Error updating refund request.");
    }
  };
  





// print data 
  const handlePrint = () => {
    const printContents = document.getElementById("admissionForm").innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };


  return (
    <div className="pb-10">
      <div className="w-full h-32 flex justify-center items-center bg-gray-50">
        <h2 className="headingTxt">Refunds</h2>
      </div>

      <div id="admissionForm" className="px-10">
        <div className="flex items-center justify-between py-5  border-b-2 border-gray-200">
          <div>
            <h1 className="headingText">Refund Details</h1>
          </div>
          {/* <div><h1 className='headingTextLink'>Back</h1></div> */}
        </div>
        <div className="flex items-center justify-between py-5">
          <div>
            <h1 className="Invoice">
              Invoice : <span className="jobDetails">{InvoiceId}</span>
            </h1>
            <h1 className="Invoice mt-2">
              Payment Receive Date : <span className="jobDetails"></span>
            </h1>
            <h1 className="Invoice mt-2">
              Job Start Date : <span className="jobDetails"></span>
            </h1>
          </div>
          <div className="print:hidden">
            <Link to={`/dashboardTwo/AllInvoiceJobDetails/${data._id}`}>
              <h1 className="tutorDetails">Job Details</h1>
            </Link>
            <button onClick={handlePrint}>
              <h1 className="tutorDetails mt-3">Download</h1>
            </button>
          </div>
        </div>
        <div className="flex lg:items-center lg:flex-row sm:flex-col lg:justify-between mt-5">
          <div>
            <h1 className="billedTo">Billed To :</h1>
            <h1 className="Invoice mt-5">
              Name : <span className="invoicePera">{data.teacherName}</span>
            </h1>
            <h1 className="Invoice mt-3">
              Address :{" "}
              <span className="invoicePera">
                {data.teachercity} {data.teacherarea}
              </span>{" "}
            </h1>
            <h1 className="Invoice mt-3">
              Phone : <span className="invoicePera">{data.teacherPhone}</span>{" "}
            </h1>
          </div>
          <div className="sm:mt-5">
            <h1 className="billedTo">From</h1>
            <h1 className="InvoicePera mt-5">Teacher Today</h1>
            <h1 className="InvoicePera mt-3">Sugandha, Panchlaish</h1>
            <h1 className="InvoicePera mt-3">teacherstoday.ctg@gmail.com</h1>
          </div>
        </div>
        <div className="w-full bg-gray-100 h-10 flex justify-end items-center mt-5">
          <h1 className="textAmount mr-3">Amount </h1>
        </div>
        <div className="w-full h-10 flex justify-between items-center mt-5">
          <h1 className="textAmount">Job Id: {data.StudentsJobID}</h1>
          <h1 className="textAmount mr-3">{data.inputData} tk</h1>
        </div>
        <div className="w-full h-10 flex justify-end items-center mt-5">
          <h1 className="textAmountTotal mr-3">Total: {data.inputData} tk</h1>
        </div>
        <div className="flex flex-col justify-start">
         
          <div className="flex flex-col justify-start mt-3">
            <div className="flex flex-row w-full items-center ">
              <div className="w-32">
                <h1 className="Paid">Paid From:</h1>
              </div>
              <input
                type="text"
                id="default-input"
                name="RefundAdminPhoneNumber"
                onChange={(e) => setInputNumber(e.target.value)}
                class="bg-gray-50 border border-gray-300 ml-3 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-40 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              />
            </div>
            <div className="flex justify-between lg:flex-row sm:flex-col">
              <div className="flex flex-row items-center mt-3 w-84">
                <div className="w-full">
                  <h1 className="Paid">Payment Method:</h1>
                </div>
                <select
                  className="select select-bordered w-40 ml-3"
                  value={selectedPaymentMethod}
                  onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                >
                  <option disabled value="">
                    Select
                  </option>
                  <option value="BKash">BKash</option>
                  <option value="Nagad">Nagad</option>
                  <option value="Rocket">Rocket</option>
                  <option value="Cash">Cash</option>
                </select>
              </div>
            </div>
            <div className="flex flex-row justify-between mt-5">
              <div className="flex flex-row">
                <div>
                  <div className="translate-y-3 ml-5 bg-white w-28 flex justify-center items-center textMain">
                    Refund Reason
                  </div>
                  <input
                    type="text"
                    onChange={(e) => setRefundReason(e.target.value)}
                    placeholder="Text..."
                    className="input border-2 border-orange-500  h-[60px] input-warning w-full "
                  />
                </div>
                <div className="ml-5">
              <div className="translate-y-3 ml-5 bg-white w-20 flex justify-center items-center textMain">
                Add file
              </div>

              <div className="border-2 border-orange-400  py-5 flex justify-between px-5 rounded-xl h-[60px]">
                <div>
                  <input
                    type="file"
                    id="fileInput"
                    accept=".pdf, .jpg, .jpeg, .png, .gif, .mp4, .webm"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    multiple
                  />
                  <button
                    onClick={() => document.getElementById("fileInput").click()}
                  >
                    <h1 className="font-semibold text-sm pr-5" id="fileLabel">
                      JPG / PNG / PDF
                    </h1>
                  </button>
                </div>

                <div>
                  <button
                    onClick={() => document.getElementById("fileInput").click()}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M11.2435 18.7566C11.2435 19.0863 11.1125 19.4026 10.8793 19.6358C10.6461 19.869 10.3298 20 10 20C9.67025 20 9.35397 19.869 9.12078 19.6358C8.8876 19.4026 8.75658 19.0863 8.75658 18.7566L8.76537 11.2347L1.24343 11.2435C0.913656 11.2435 0.597389 11.1125 0.364192 10.8793C0.131007 10.6461 0 10.3298 0 10C0 9.67027 0.131007 9.35399 0.364192 9.12081C0.597389 8.88762 0.913656 8.7566 1.24343 8.7566L8.76537 8.7654L8.75658 1.24343C8.75658 0.913656 8.8876 0.597377 9.12078 0.364192C9.35397 0.131007 9.67025 0 10 0C10.3298 0 10.6461 0.131007 10.8793 0.364192C11.1125 0.597377 11.2435 0.913656 11.2435 1.24343L11.2347 8.7654L18.7567 8.7566C19.0864 8.7566 19.4027 8.88762 19.6359 9.12081C19.8691 9.35399 20.0001 9.67027 20.0001 10C20.0001 10.3298 19.8691 10.6461 19.6359 10.8793C19.4027 11.1125 19.0864 11.2435 18.7567 11.2435L11.2347 11.2347L11.2435 18.7566Z"
                        fill="#FE7702"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
              </div>
              <div className="flex flex-row justify-center items-center  print:hidden">
                <div className="flex flex-col">
                <button
                      onClick={() =>
                        handleClassBooked(
                          data._id,
                          inputNumber,
                          selectedPaymentMethod,
                          refundReason
                        )
                      }
                      className="buttonSent"
                    >
                      Submit
                </button>
             
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isOpen && selectedItem && (
        <div className="container max-w-[1000px] mx-auto">
          <div className="contentApplication bg-white rounded-xl py-5 border border-gray-200">
            <div className="flex flex-row  justify-between px-10 ">
              <div>
                <h1 className="modalTittleAppli">Tutor Details</h1>
              </div>
              <div className="justify-end">
                <div>
                  <div className="flex justify-end items-center">
                    <button
                      onClick={() => setIsOpen(false)}
                      className="w-8 h-8 rounded-full flex justify-center items-center bg-orange-300 hover:bg-orange-400"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <hr className="h-2 mt-10 w-full"></hr>

            {/* Display data from selectedItem in the modal */}
            <div className="px-10">
              <div className="w-full">
                <h1 className="text-right download">Download</h1>
              </div>
              <div className="h-[600px] overflow-y-auto">
                <div className="rounded-lg border-2 mt-5">
                  <div className="px-5 py-3 flex justify-between items-center">
                    <h1 className="applicationModalOne">
                      Personal Information
                    </h1>
                  </div>
                  <hr className="h-2"></hr>
                  <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Name :</span> Md Jahidul
                        Islam
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Gender :</span> Male
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Religion:</span> Islam
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Phone :</span>{" "}
                        01684858866
                      </h1>
                    </div>

                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">City :</span> Dhaka
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Area :</span>{" "}
                        Mohammadpur
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera"></span>NID / Birth
                        Certificate / Passport :
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Emergency :</span>{" "}
                        01684858866
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg border-2 mt-5">
                  <div className="px-5 py-3 flex justify-between items-center">
                    <h1 className="applicationModalOne">
                      Educational Information
                    </h1>
                  </div>
                  <hr className="h-2"></hr>
                  <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">
                          Level of Education :
                        </span>
                        Honors/Diploma
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Institute :</span> UIU
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Certificate :</span>{" "}
                        Islam
                      </h1>
                    </div>

                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Semester/Year :</span>{" "}
                        12th{" "}
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Major/Subject :</span>{" "}
                        CSE
                      </h1>
                    </div>
                  </div>
                  <hr className="h-2 mt-3 mx-5"></hr>
                  <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">
                          Level of Education :
                        </span>
                        Honors/Diploma
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Institute :</span> UIU
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Certificate :</span>{" "}
                        Islam
                      </h1>
                    </div>

                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Group :</span> 12th{" "}
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Passing Result :</span>
                        A+
                      </h1>
                    </div>
                  </div>
                  <hr className="h-2 mt-3 mx-5"></hr>
                  <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">
                          Level of Education :
                        </span>
                        Honors/Diploma
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Institute :</span> UIU
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Certificate :</span>{" "}
                        Islam
                      </h1>
                    </div>

                    <div className="w-full pb-5">
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Group :</span> 12th{" "}
                      </h1>
                      <h1 className="text-left modalDetailsText mt-5">
                        <span className="modalTextPera">Passing Result :</span>
                        A+
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg border-2 mt-5">
                  <div className="px-5 py-3 flex justify-between items-center">
                    <h1 className="applicationModalOne">Teaching Experience</h1>
                  </div>
                  <hr className="h-2"></hr>
                  <div className="px-5 py-4">
                    <p className="peraText">
                      Lorem ipsum dolor sit amet consectetur. Urna porttitor
                      amet in facilisis. Vitae congue egestas pretium cursus
                      nulla. Ridiculus ornare pellentesque facilisis cras
                      hendrerit porttitor luctus turpis. Posuere neque quis leo
                      molestie dui quis nisl. Blandit amet amet nunc ut
                      condimentum nisl in amet. Vitae odio sagittis sollicitudin
                      duis ornare felis aliquam adipiscing. Auctor turpis
                      pharetra faucibus urna mauris at nisl molestie. Sit sem
                      amet faucibus sed at. Nunc dignissim imperdiet commodo in
                      nam id elit eu pellentesque. Faucibus vel vivamus volutpat
                      nulla. Velit orci placerat vel in risus vestibulum. Diam
                      lacus amet nibh cursus vel convallis. Orci adipiscing quam
                      nisi faucibus lobortis lorem magna vestibulum tempus.
                      Mauris euismod venenatis feugiat ligula non tellus amet a
                      elementum. Eget ac dictum commodo rhoncus amet quis dui
                      massa blandit. Turpis id donec morbi in sit ac. Blandit
                      quam gravida placerat conse
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Add more elements to display other properties */}
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestRefundsDetails;
